<template>
<div class="upnext-container">
  <div class="next-projects-container">
    <h4>{{title}}</h4>
    <div class="slides-container">
      <router-link to="all_modules/advisory" v-on:click.native="handleDashMod('a')"><ProjectCard 
        class="project-card proj1 inactive" 
        project="Advisory" 
        module="ADV" 
        dept="16 projects" 
        color="#20356A" 
        ref="Advisory"
      /></router-link>
      <router-link to="all_modules/managed_services" v-on:click.native="handleDashMod('m')"><ProjectCard 
        class="project-card proj2 mod-active" 
        project="Managed Services" 
        module="MS" 
        dept="1 project" 
        color="#2E4FA3"
        ref="ManagedServices"
      /></router-link>
      <router-link to="all_modules/operations" v-on:click.native="handleDashMod('o')"><ProjectCard 
        class="project-card proj3 inactive" 
        project="Operations" 
        module="OPS" 
        dept="6 projects" 
        color="#478A69" 
        ref="Operations"
      /></router-link>
    </div>
  </div>
</div>
</template>

<script>
import ProjectCard from '@/components/ProjectCard';
import store from '@/store';
//import firebase from 'firebase';

export default {
  name: 'UpNext',
  props: {
    user: Object,
    title: String
  },
  components: {
    ProjectCard
  },
  methods: {
    fetchUpnext() {
      console.log("fetching next 4 chronological modules");
      /*firebase.firestore().collection("quizzes").get().then((docs) => {
      docs.forEach(doc) {
        
      }
      });*/
    },
    handleDashMod(mod) {
      console.log('commiting state change');
      store.commit('dashMod', mod);
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/global-styles/variables.scss';

.mod-active {
  
}

.inactive {
  //background: white;
  //color: black;
  //background:white;
  //color: black;
}

h4 {
  margin-bottom: $gap;
  text-align: center;
  opacity: 0.4;
}

.upnext-container {
    text-align: center;
    padding: 0px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .next-projects-container {
      width: 100%;
    }
}

.slides-container {
  display: grid;
  grid-template-rows: 1fr 1fr 1fr !important;
  margin:auto;
  width:75%;
  grid-gap: $gap;
}

p {
    margin: 24px 0px;
}

.project-card {
  opacity: 0;

  &:hover {
    transform: scale(1.02);
  }
}

.proj1 {
  animation: flyin 1s ease forwards;
  animation-delay: 0.8s;
}

.proj2 {
  animation: flyin 1s ease forwards;
  animation-delay: 1.0s;
}

.proj3 {
  animation: flyin 1s ease forwards;
  animation-delay: 1.2s;
}

.proj4 {
  animation: flyin 1s ease forwards;
  animation-delay: 1.4s;
}
</style>